<template>
    <div id="EditarInformacoes">
        <div class="container">
            <div class="row">
                <div class="col-md-9 col-sm-9 col-11">
                    <div class="row">
                        <div class="col-12 div-top">
                            <div class="div-usuario">
                                <img :src="icone_Usuario" alt="">
                                <div class="infos">
                                    <span class="span_bem_vindo">
                                        Bem vindo (a)
                                    </span>
                                    <span class="nome">
                                        {{cliente.nome}}
                                    </span>
                                </div>
                            </div>
                            <div class="wrapper-btns">
                                <!-- <button @click="voltaHomeCardapio()">
                                    <img :src="icone_Home" alt="">
                                </button> -->
                                <a href="javascript:history.back()">
                                    <v-icon>fas fa-times</v-icon>
                                </a>
                            </div>
                        </div>
                        <div class="col-12 div-editar-perfil">
                            <v-form ref="form_edita_usuario" class="row">
                                <div class="col-12">
                                    <label class="primary-text-field-label">Nome*</label>
                                    <v-text-field
                                        class="primary-text-field"
                                        :rules="[v => !!v || 'Campo obrigatório']" 
                                        v-model="cliente.nome"
                                        placeholder="Nome"                                        
                                        solo
                                        hide-details
                                    />
                                </div>
                                <div class="col-md-6 col-12">
                                    <label class="primary-text-field-label">E-mail*</label>
                                    <v-text-field
                                        class="primary-text-field"
                                        :rules="[v => !!v || 'Campo obrigatório']" 
                                        v-model="cliente.email"
                                        placeholder="E-mail"                                        
                                        solo
                                        hide-details
                                    />
                                </div>
                                <div class="col-md-6 col-12">
                                    <label class="primary-text-field-label">Senha</label>
                                    <v-text-field
                                        class="primary-text-field"
                                        type="password"
                                        v-model="cliente.senha"
                                        placeholder="Senha"
                                        solo
                                        hide-details
                                    />
                                </div>
                                <div class="col-md-6 col-12">
                                    <label class="primary-text-field-label">Telefone*</label>
                                    <v-text-field
                                        class="primary-text-field"
                                        :rules="[v => !!v || 'Campo obrigatório']" 
                                        v-model="cliente.telefone"
                                        placeholder="Telefone"                                        
                                        solo
                                        hide-details
                                        v-mask="'(##)#####-####'"
                                    />
                                </div>
                                <div class="col-md-6 col-12">
                                    <label class="primary-text-field-label">CPF*</label>
                                    <v-text-field
                                        class="primary-text-field"
                                        :rules="[v => !!v || 'Campo obrigatório']" 
                                        v-model="cliente.cpf"
                                        placeholder="CPF"                                        
                                        solo
                                        hide-details
                                        v-mask="'###.###.###-##'"
                                    />
                                </div>
                                <div class="col-sm-6 offset-sm-3 col-12">
                                    <label class="primary-text-field-label">Deseja receber notificações por WhatsApp?</label>
                                    <div class="row">
                                        <v-switch
                                            v-model="cliente.receber_notificacao"
                                            hide-details
                                        />
                                        <v-text-field
                                            :disabled="!cliente.receber_notificacao"
                                            v-model="cliente.telefone_notificacao"
                                            placeholder="Telefone"
                                            v-mask="'(##)#####-####'"
                                            hide-details
                                        />
                                    </div>
                                </div>
                            </v-form>
                        </div>
                        <div class="col-12 div-bottom">
                            <button class="primary-button" @click="editaUsuario()">
                                Salvar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loader v-if="loading"/>
    </div>
</template>

<script>
    import store from '@/store'
    import IconeUsuario from '@/assets/images/REDIRECTUSUARIO.png'
    import IconeSair from '@/assets/images/SAIR.png'
    import IconeHome from '@/assets/images/HOMEICON.png'
    import Loader from '@/components/Loader.vue'

    export default {
        name: 'EditarInformacoes',
        components: {
			Loader,
		},
        data: () => ({
            icone_Usuario: IconeUsuario,
            icone_Sair: IconeSair,
            icone_Home: IconeHome,
            loading: false,
            cliente: {
                codigo: '',
                nome: '',
                cpf: '',
                email: '',
                senha: null,
                telefone: '',
                receber_notificacao: '',
                telefone_notificacao: ''
            },
            estados: [],
            cidades: [],
        }),
        methods: {
            async init(){
                this.cliente.codigo = store.getters.clientes.usuario.id
                this.cliente.nome = store.getters.clientes.usuario.nome
                this.cliente.cpf = store.getters.clientes.usuario.cpf
                this.cliente.email = store.getters.clientes.usuario.email
                // this.cliente.senha = store.getters.clientes.usuario.
                this.cliente.telefone = store.getters.clientes.usuario.telefone
                this.cliente.receber_notificacao = store.getters.clientes.usuario.receber_notificacao
                this.cliente.telefone_notificacao = store.getters.clientes.usuario.telefone_notificacao

            },
            voltaHomeCardapio(){
                this.$router.push('/' + this.$route.params.url_amigavel + '/home/')
            },
            async editaUsuario(){
                let temp_usuario = {
                    codigo: this.cliente.codigo,
                    nome: this.cliente.nome,
                    cpf: this.cliente.cpf,
                    email: this.cliente.email,
                    telefone: this.cliente.telefone,
                    receber_notificacao: this.cliente.receber_notificacao,
                    telefone_notificacao: this.cliente.telefone_notificacao,
                }
                
				if (this.$refs.form_edita_usuario.validate()) {
                    if (this.cliente.senha) {
                        temp_usuario.senha = this.cliente.senha
                    }
                    this.loading = await true
                    var resp = await store.dispatch('salvaCliente', temp_usuario)
                    if (resp.sucesso) {
                        this.$swal({
                            icon:'success',
                            text: 'Usuário editado com sucesso!',
                            showCancelButton: false,
                            showCloseButton: false,
                            showConfirmButton: false,
                        })
                        this.loading = await false
                        document.location.reload(true);
                    }else{
                        this.$swal({
                            title: 'Atenção',
                            icon:'error',
                            text: 'Não foi possível concluir as alterações!',
                            showCancelButton: false,
                            showCloseButton: false,
                            showConfirmButton: true,
                            confirmButtonText:'Ok'
                        })
                        this.loading = await false
                    }
				}
			},
        },
        async mounted(){
            await this.init()
        }
    }
</script>

<style lang="scss">
    #EditarInformacoes{
        position: relative;
        .div-top{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .div-usuario{
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                .infos{
                    display: flex;
                    flex-wrap: wrap;
                    flex-direction: column;
                    padding-left: 23px;
                    span{
                        font-family: 'Poppins';
                        font-style: normal;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 24px;
                        color: #000000;
                        &.span_bem_vindo{
                            font-weight: 700;
                        }
                        &.localizacao{
                            font-size: 18;
                            font-family: 'JosefinSans';
                        }
                    }
                }
                .icones{
                    img{
                        padding-left: 25px;
                    }
                }
            }
            .wrapper-btns{
                display: flex;
                align-items: center;
                svg{
                    font-size: 25px;
                    margin-left: 10px;
                    background-color: transparent;
                    width: 40px;
                    height: 40px;
                    padding: 8px;
                    border-radius: 30px;
                    transition: all ease .3s;
                    path{
                        fill: $primarycolor;
                    }
                    &:hover{
                        background-color: #f3f3f3;
                    }
                    &:active{
                        background-color: #dadada;
                    }
                }
            }
            @media (max-width: 350px){
                flex-direction: column;
                text-align: center;
                align-items: center;
                justify-content: center;
                .wrapper-btns{
                    margin-top: 15px;
                }
            }
        }
        .div-editar-perfil{
            form{
                font-family: Poppins;
                padding: 18px 0;
                h2{					
                    font-style: normal;
                    font-weight: 500;
                    font-size: 22px;
                    line-height: 36px;
                    color: $primarycolor;
                }
                .v-input__slot{
                    border-radius: 100px!important;
                    padding-left: 15px!important;
                }
                .lembrar-usuario{
                    display: flex;
                    align-items: center;
                    label{
                        display: flex;
                        align-items: center;
                        margin-bottom: 0;
                        p{
                            padding: 0px;
                            font-style: normal;
                            font-weight: normal;
                            font-size: 14px;
                            line-height: 17px;
                            color: #373737;
                        }
                        input{
                            width: auto;
                            margin-right: 10px;
                        }
                    }
                    .v-input__slot{
                        border-radius: inherit!important;
                        padding: inherit!important;
                    }
                }
                .recuperar-senha{
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    text-align: right;
                    a{
                        text-align: right;
                        font-style: normal;
                        font-weight: normal;
                        font-size: 16px;
                        line-height: 20px;
                        color: rgba(0,0,0,.6);
                    }
                    .v-input__slot{
                        border-radius: inherit!important;
                        padding: inherit!important;
                    }
                }
                .div-wrapper-btn{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    align-items: center;
                    .btn-entrar{
                        border-radius: 100px;
                        max-width: 360px!important;
                        padding: 18px 20px;
                        width: 360px!important;
                        height: 60px;
                        span{
                            font-family: 'Poppins';
                            font-style: normal;
                            font-weight: bold;
                            font-size: 16px;
                            line-height: 24px;
                            color: #FFFFFF;
                            display: inline-flex;
                        }
                    }
                }
                .wrapper-novo-usuario{
                    padding-top: 30px;
                    span{
                        font-family: 'Poppins';
                        font-style: normal;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 24px;
                        color: #747474;
                    }
                    .btn-cadastrese{
                        background-color: transparent!important;
                        box-shadow: inherit!important;
                        padding: 0 6px!important;
                        span{
                            font-family: Poppins;
                            font-style: normal;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 24px;
                            color: #747474;
                        }
                        &:before{
                            content: none!important;
                        }
                        &:hover{
                            background-color: transparent!important;
                        }
                    }
                }
                @media (max-width: 1400px){
                    padding: 0 15px;
                }
            }
        }
        .div-bottom{
            .primary-button{
                min-height: 60px;
                width: max-content;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
                border-width: 2px;
            }
            @media (max-width: 1400px){
                padding: 0 27px;
            }
        }
        &:before{
            content: '';
            position: fixed;
            top: 0;
            right: 0;
            background-position: center;
            width: 25%;
            height: 100vh;
            z-index: 1;
            background-repeat: no-repeat;
            background-size: cover;
            background-image: url('~@/assets/images/sideEditUsuario.png');
            @media (max-width: 599px){
                display: none;
            }
        }
    }
</style>